
import axios from "axios";
import uuid from "uuidv4";

/*
* Upload file to S3 given a file, filename, extension and the name of the folder
* Optional Param: Unique ID. If you do not provide one, a unique id will be created for you
* Optional Param: Callback. Calls callback function on success
*/
export function uploadS3(file, filename, extension, folder, unique_id=null, callback=null, error_callback=null) {
    var formData = new FormData();
    if (unique_id === null) {
        unique_id = uuid();
    }
    filename = filename.replace(/[^_A-Z0-9]+/ig, "");
    filename = filename + "_" + unique_id

    formData.append("file", file);
    formData.append("folder", folder)
    formData.append("filename", filename)
    formData.append("extension", extension)

    axios.post('/ajax/uploadfile', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    .then(function(response) {
        if (callback) {
            callback(response?.data.file_name)
        }
    })
    .catch(function(error){
        if (error_callback) {
            error_callback(error, file)
        }
    })
}